import React from 'react'
import { Dropdown, Menu } from 'antd'
import { DownOutlined } from '@ant-design/icons'
import * as DROPDOWN from 'constant/dropdown'
import EditDataset from 'view/page/dataset-management/component/edit-dataset'
import formatArticle from 'helper/format-input-fields'
import PropTypes from 'prop-types'
import Attachments from 'view/page/dataset-management/component/attachments'
import EditAuthor from 'view/component/table-columns/common-actions/edit-author'
import DeleteDataset from './component/delete'
import PinDataset from './component/pin'
import PublishDataset from './component/publish'
import styles from './styles'

const Action = ({ dataset }) => (
  <span>
    <Dropdown
      overlay={
        <Menu>
          <Menu.Item>
            <EditDataset dataset={formatArticle(dataset)} />
          </Menu.Item>
          <Menu.Item>
            <DeleteDataset dataset={dataset} />
          </Menu.Item>
          <Menu.Item>
            <PublishDataset dataset={dataset} />
          </Menu.Item>
          <Menu.Item>
            <PinDataset dataset={dataset} />
          </Menu.Item>
          <Menu.Item>
            <Attachments dataset={dataset} />
          </Menu.Item>
          <Menu.Item>
            <EditAuthor article={formatArticle(dataset)} />
          </Menu.Item>
        </Menu>
      }
      overlayStyle={{ zIndex: 1 }}
      trigger={[DROPDOWN.TRIGGER]}
    >
      <div className={styles.show_more}>
        <span>More</span>
        <DownOutlined />
      </div>
    </Dropdown>
  </span>)

Action.propTypes = {
  dataset: PropTypes.object
}

export default Action
